import { render, staticRenderFns } from "./programInfo.vue?vue&type=template&id=f669a3ee&scoped=true&"
import script from "./programInfo.vue?vue&type=script&lang=js&"
export * from "./programInfo.vue?vue&type=script&lang=js&"
import style0 from "./programInfo.vue?vue&type=style&index=0&id=f669a3ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f669a3ee",
  null
  
)

export default component.exports